// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"212":"748ecacd24ccbeaf","415":"bd18ea93c2ec1ed2","496":"d013550624775fa4","854":"7c6457af97965511","881":"187f93945c46b9f3"}[chunkId] + ".js";
};